import React, { useContext, useRef, useTransition, useState } from "react";
import AgoraRTC from "agora-rtc-sdk-ng";
import AgoraRTM from "agora-rtm-sdk";
import { Avatar, Button, Box, IconButton, Snackbar, Stack, Typography } from "@mui/material";
import PushPinIcon from "@mui/icons-material/PushPin";
import "./index.scss";
import {
  beep,
  fullName,
  getAudienceId,
  getErrorString,
  getUserDetail,
  getUserId,
  hasPremium,
  isMobile,
  isOwnerId,
  putStreamRecord,
  screenWidth,
} from "../../constants/function";
import StreamHeader from "../../components/Stream/AudiencCardContainer/StreamHeader";
import StreamTippers from "../../components/Stream/AudiencCardContainer/StreamTippers";
import AddMusicToPlaylist from "../../components/AddMusicToPlaylist";
import GavelIcon from '@mui/icons-material/Gavel';

import StreamingControls from "../../components/Stream/StreamingControls";
import { useDispatch, useSelector } from "react-redux";
import { leaveStream, startStream, updatePos } from "../../action/stream";
import { SocketContext } from "../../context/socket";
import cookieStorage from "../../services/cookie-storage";
import { Images } from "../../assets/common";
import TopListPopup from "../../components/TopListPopup";
import SuccessPopup from "../../components/SuccessPopup";
import notifier from "../../components/Notifier";
import { useEffect } from "react";
import Loader from "../../components/Loader";
import TipPopup from "../../components/TipPopup";
import ApiService from "../../services/api-service";
import { getBalance } from "../../asyncAction/asyncBalance";
import NftList from "../../components/DirectChat/nftList";
import PanToolIcon from "@mui/icons-material/PanTool";
import Slide from "@mui/material/Slide";
import CloseIcon from "@mui/icons-material/Close";
import { useHistory, useParams } from "react-router-dom";
import * as io from "socket.io-client";
import { SERVER_URL } from "../../constants/api";
import { useTranslation } from "react-i18next";
import { start } from "../../action/streamSong";
import { updatecount } from "../../action/adv";
import StreamShow from "../../components/Stream/StreamShow";
import { Flags } from 'react-feature-flags';
import emitter from '../../EventEmitter';
import ActiveListings from "../../components/Stream/ActiveListings";



var rtc = {
  client: null,
  joined: false,
  published: false,
  localStream: null,
  remoteStreams: [],
  params: {},
};
var rtc_screen = {
  client: null,
  isVideo: true,
  published: false,
  localStream: null,
  remoteStreams: [],
  params: {},
};
// Options for joining a channel
var option = {
  appId: "1d8d22987b394e23a9938498b6f28c04",
  channel: "",
  uid: null,
  token: null,
  key: "",
  secret: "",
  role: "host",
};
var remoteUsers = {};
var isLoggedIn = false;
var streamDataLocal = null;
var isOwner = false;
var on = false;
var Socket = null;
// AgoraRTC.enableLogUpload();
// AgoraRTC.setLogLevel(1);
rtc.client = AgoraRTC.createClient({ mode: "live", codec: "h264" });
var interval;
var audioFileTrack;

function Streaming({
  streamData,
  title,
  goal,
  createdBy,
  isNew,
  music,
  goalDescription,
  shareUrl,
  isJoined, setIsJoined,
  tokenData, setTokenData,
  songData, setSongData,
  obs = false,
}) {
  const isPremium = hasPremium();
  const [userStream, setUserStream] = React.useState();
  const [play, setPlay] = React.useState(false);
  const { t } = useTranslation("common");
  const [mics, setMics] = React.useState([]); // all microphones devices you can use
  const [cameras, setCamera] = React.useState([]); // all microphones devices you can use
  const [currentMic, setCurrentMic] = React.useState(null); // the microphone you are usingmics={mics}
  const [currentCamera, setCurrentCamera] = React.useState(null);
  const { setSocket } = useContext(SocketContext);
  const history = useHistory();
  const params = new URLSearchParams(history.location.search);
  // const { playlistId } = useParams();
  const playlistId = params.get("playlistId");
  const [raisedList, setRaisedList] = React.useState([]);
  const [raisedUser, setRaisedUser] = React.useState({});
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [showNft, setShowNft] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const userId = getUserId();
  const [openTip, setOpenTip] = React.useState(false);
  const [openGift, setOpenGift] = React.useState(false);
  const [userData, setUserData] = React.useState({});
  const [success, setSuccess] = React.useState(false);
  const [openUser, setOpenUser] = React.useState(false);
  const [liveUser, setLiveUser] = React.useState([]);
  const socket = useContext(SocketContext).Socket;
  const dispatch = useDispatch();
  const [isVideo, setIsVideo] = React.useState(true);
  const [isMute, setIsMute] = React.useState(false);
  const [hostMuted, setHostMuted] = React.useState(false);
  const [video, setVideo] = React.useState(true);
  const [mode, setMode] = React.useState("video");

  const token = cookieStorage.getCookie("Authorization");
  const [isLive, setLive] = React.useState(false);
  const [isFullScreen, setIsFullScreen] = React.useState(false);
  const [tippers, setTippers] = React.useState(false);
  const [audienceRole, setAudienceRole] = React.useState({});
  const [audienceIndex, setAudienceIndex] = React.useState(null);
  const [role, setRole] = React.useState("");
  const Uid = useRef(null);
  const userDetail = getUserDetail();
  const liveUserRef = useRef([]);
  const [message, setMessage] = React.useState(null);
  const [isStreaming, setIsStreaming] = React.useState(false);
  const [followings, setFollowings] = React.useState([]);
  const { count } = useSelector((state) => state.adv);
  const [obsUrl, setObsUrl] = React.useState(null);
  const [fromObs, setfromObs] = React.useState(false);
  const [channel, setChannel] = React.useState(null);
  const [showPlaylist, setShowPlaylist] = useState(false); // State for controlling the playlist modal

  const artistId = streamData?.createdBy; // This should be the user ID of the stream's host/artist

  const [showActiveListings, setShowActiveListings] = useState(false);








  


  React.useEffect(() => {
    emitter.on('endStream', endStream);
    emitter.on('openNft', () => openNft);
    emitter.on('closeNft', () => closeNft);

    streamDataLocal = streamData;
    isOwner = isOwnerId(streamData?.owner);
    const path = history.location.pathname;
    if (streamDataLocal) {
      const payload = {
        channelName: streamDataLocal._id,
        role: isOwner ? "host" : "audience",
        JWT: token,
        platform: "web",
      };
      if (isOwner) {
        payload.goalAmount = goal;
        payload.goalTitle = title;
        payload.goalDescription = goalDescription;
        payload.isNew = isNew;
        payload.fromObs = obs ? true : null;
      }
      localStorage.removeItem("streamIndex");
      socket.emit("stream-start", payload);
      setChannel(streamDataLocal._id);
    } else if (
      playlistId &&
      path.includes("/app/LiveVideoStreaming/")
      // &&
      // isMobile.any()
    ) {
      if (token) {
        const skt = io.connect(SERVER_URL, {
          auth: { JWT: token },
          transports: ["websocket"],
          reconnection: true,
        });
        setSocket(skt);
        getPlaylistDetail(playlistId, skt);
      }
    } /*else if (
      !history.location.pathname.includes("/app/LiveVideoStreaming/")
    ) {
      history.push("/app/Home");
      window.location.reload();
    }*/

    return () => {
      if (emitter) {
        // emitter.off('endStream', endStream);
        // emitter.off('openNft', openNft);
        // emitter.off('closeNft', closeNft);
      }
    }
  }, [streamData]);

  React.useEffect(() => {
    setIsStreaming(tokenData?.token);
  }, [tokenData]);

  const getPlaylistDetail = async (channelName, skt) => {
    try {
      setLoading(true);
      setMessage(t("loader.message18"));
      if (skt) setMessage(t("loader.message19"));
      else setMessage(t("loader.message20"));
      const response = await ApiService.PLAYLIST_DETAIL({
        _id: channelName,
        pageNo: 1,
        pageSize: 1,
      });

      if (
        response?.result?.live &&
        !response?.result?.isSubscribed &&
        response?.result?.private
      ) {
        setLoading(false);

        notifier.error(t("notifier.error.toast4"));
        setLoading(false);
        history.push("/app/Home");
        return;
      }
      if (!response?.result?.live) {
        notifier.error(t("notifier.error.toast3"));
        setLoading(false);
        history.push("/app/Home");
        return;
      }
      const status = await getBlockedUserOfPlaylist(channelName);
      if (typeof status === "boolean" && status) {
        notifier.error(t("notifier.error.toast2"));
        setLoading(false);
        history.push("/app/Home");
        return;
      }

      isOwner = isOwnerId(response?.result?.nftOwner?.owner);

      streamDataLocal = response?.result;
      const payload = {
        channelName: streamDataLocal._id,
        role: isOwnerId(response?.result?.nftOwner?.owner)
          ? "host"
          : "audience",
        JWT: token,
        platform: "web",
      };
      if (isOwnerId(response?.result?.nftOwner?.owner)) {
        payload.goalAmount = goal;
        payload.goalTitle = title;
        payload.goalDescription = goalDescription;
        payload.isNew = isNew;
      }
      setMessage(null);
      if (skt) skt.emit("stream-start", payload);

      setLoading(false);
    } catch (error) {
      setMessage(null);

      notifier.error(getErrorString(error));
      setLoading(false);
      if (
        getErrorString(error) ===
        "This is an explicit content you need to be above 18 to view it"
      ) {
        history.push("/app/Home");
      }
    }
  };

  const getBlockedUserOfPlaylist = async (roomid) => {
    try {
      const response = await ApiService.BLOCKER_USER(roomid);
      return response?.result?.isBlocked;
    } catch (error) {
      return null;
    }
  };

  React.useEffect(() => {
    // Listening live users joined the streaming
    if (socket) {
      socket.on("audience-in-stream", function (data) {
        if (
          data &&
          data.liveUsers &&
          data.liveUsers.length > 0 &&
          data.liveUsers[0]?.channelName === streamDataLocal._id
        ) {
          setLiveUser([...data.liveUsers]);
          liveUserRef.current = data.liveUsers;
          // const foundIndex = findCoHost(data.liveUsers);
          // if (foundIndex >= 0) {
          //   mute(!data?.liveUsers[foundIndex]?.user.mic);
          // }
        } else if (data && data.channelName === streamDataLocal._id) {
          setLiveUser([]);
        }
      });
      // Listingin for token
      socket.on("stream-joined", function (data) {
        const userId = getUserId();
        // dispatch(updatecount((count = 0)));
        if (data.userId === userId) {
          option.token = data.token;
          option.appId = data.appId;
          option.uid = data.uid;
          setTokenData({ ...data });

          
          if (data.fromObs && data.obsUrl) {
            // Ensure only set if current stream mode is OBS
            if (obs) {
              setObsUrl(data.obsUrl);
              setfromObs(data.fromObs);
            }
          }


          if (
            streamDataLocal._id &&
            isOwner &&
            rtc.client &&
            data.channelName === streamDataLocal._id &&
            data.userId === userId
          ) {
            setRole("host");
            joinChannel("host", streamDataLocal._id, "video", data.appId);
            setLive(true);
            setFollowings([...data.followings]);
            if (!isPremium) dispatch(updatecount(1));
          } else if (
            streamDataLocal._id &&
            !isOwner &&
            rtc.client &&
            data.channelName === streamDataLocal._id &&
            data.userId === userId
            // &&
            // data.fromObs
          ) {
            // console.log("data.fromObs", data.fromObs, data.obsUrl);
            var isObs;
            if (data.fromObs && data.obsUrl) {
              setObsUrl(data.obsUrl);
              isObs = data.fromObs;
              setfromObs(data.fromObs);
            }
            setRole("audience");
            joinChannel(
              "audience",
              streamDataLocal._id,
              "video",
              data.appId,
              false,
              isObs
            );

            if (data.songStream) {
              setSongData({ ...data.songStream });
            }
            setFollowings([...data.followings]);
            if (!isPremium) dispatch(updatecount(1));
          }
        }
      });
      // Listening for stream end so that audience live stream window can closed automatically
      socket.on("stream-ended", function (data) {
        const userId = getUserId();
        if (
          data.channelName === streamDataLocal._id &&
          data.role === "host" &&
          isOwner &&
          data.userId === userId
        ) {
          setSuccess(true);
          // rtc.client = null;
        } else if (
          data.channelName === streamDataLocal._id &&
          data.role === "host"
        ) {
          setSuccess(true);
        }
      });
      socket.once("stream-error", function (data) {
        // console.log("Streaming-----------------------------");
        const userId = getUserId();
        if (
          data.channelName === streamDataLocal._id &&
          data.userId === userId &&
          rtc.client
        ) {
          //if audience try to join streaming twice it will throw error

          if (
            data.message === "Only one live stream per user" &&
            option.token
          ) {
          } else if (
            data.message === "You are already live from another device" &&
            option.token
          ) {
          } else if (
            data.message ===
            "It's a private playlist and you are not a subscriber" &&
            history.location.pathname.includes("/app/LiveVideoStreaming/")
          ) {
            history.push("/app/Home");
          } else {
            notifier.error(data.message);
            dispatch(leaveStream());
            // if (
            //   history.location.pathname.includes("/app/LiveVideoStreaming/")
            // ) {
            //   setTimeout(() => {
            //     history.push("/app/Home");
            //     window.location.reload();
            //   }, 500);
            // } else {
              // setTimeout(() => {
              //   window.location.reload();
              // }, 500);
            // }
          }
        }
      });
      socket.on("makeCoHost", function (data) {
        if (
          data.userId === userId &&
          data.channelName === streamDataLocal._id &&
          !isOwner
        ) {
          // if (history.location.pathname.includes("/LiveVideoStreaming")) {
          // } else
          changeToHost(data.userId, data.role, data.host);
        }
      });
      //handleling raised hand by audience
      socket.on("raised", function (data) {
        if (isOwner && data.channelName === streamDataLocal._id) {
          setRaisedUser({ ...data });
          const tempUser = raisedList;
          const index = findOne(data.user.userId);
          if (index >= 0) {
            tempUser.splice(index, 1);

            setRaisedList([...tempUser]);
          } else {
            tempUser.unshift(data);
            setOpenSnackbar(true);
            setRaisedList([...tempUser]);
            beep();
          }
        }
      });
      socket.on("muted", function (data) {
        if (
          !isOwner &&
          data.channelName === streamDataLocal._id &&
          data.userId === userId
        ) {
          mute(!data.mic ? true : false, true);

          socket.emit("stream-invite", {
            userId: data.userId,
            channelName: streamDataLocal._id,
            role: "host",
            mic: data.mic,
            mutedBy: "host",
          });


          socket.emit("stream-invite", {
            userId: data.userId,
            channelName: streamDataLocal._id,
            role: "host",
            mic: data.mic,
            mutedBy: "host",
            camera: data.camera,
          });
        }
      });
      socket.on("follow-list", function (data) {
        if (
          data.channelName === streamDataLocal._id &&
          data._id === userId &&
          "followings" in data
        ) {
          setFollowings([...data.followings]);
        }
      });
      socket.on("upgrade-now", function (data) {
        const userId = getUserId();
        if (
          data.channelName === streamDataLocal._id &&
          data.userId.indexOf(userId) >= 0
        ) {
          notifier.error(t("upgradeError"));
          setTimeout(() => {
            endStream();
          }, 30000);
        }
      });
      socket.on("show-ad", function (data) {
        const userId = getUserId();
        // checking if the role is host(for owner and cohost) if yes then mute the mic before playing the ad
        if (role === "host" && data.indexOf(userId) >= 0) {
          if (rtc.localAudioTrack) {
            rtc.localAudioTrack.setEnabled(false);
            setIsMute(true);
          }
        }
      });
    }
  }, [socket]);
  function findOne(_id) {
    return raisedList.findIndex((u) => u.user.userId === _id);
  }

  useEffect(() => {
    return () => {
      //stop song if user logout
      if (audioFileTrack) {
        audioFileTrack?.stopProcessAudioBuffer();
        audioFileTrack = null;
        // window.location.reload();
      }
      // if (!audioFileTrack && rtc.client && option.token) {
      //   endStream();
      // }
      localStorage.removeItem("curretTimeInSong");
      localStorage.removeItem("streamIndex");
    };
  }, []);
  
  async function joinChannel(role, channel, mode, appId, coHost, isObs) {
    try {
      // Event listeners for audience role
      if (role === "audience") {
        rtc.client.on("user-published", handleUserPublished);
        rtc.client.on("user-joined", (user, mediaType) => handleUserJoined(user, mediaType, isObs));
        rtc.client.on("user-left", handleUserLeft);
        rtc.client.on("user-unpublished", handleUnPublised);
        rtc.client.on("volume-indicator", handleVolume);
      }
  
      // Set the client role (host, audience, cohost) and join the channel
      await rtc.client.setClientRole(role);
      await rtc.client.join(appId, channel, option.token, option.uid);
      const uid = option.uid;
  
      // Emit stream update to the server
      socket.emit("stream-update", {
        channelName: streamDataLocal._id,
        role: isOwner ? "host" : "audience",
        uid: uid,
        userId: userId,
      });
  
      // Enable audio volume indicator for the stream
      rtc.client.enableAudioVolumeIndicator();
  
      // Initialize microphone for host and cohost
      if (role === "host" || coHost) {
        try {
          const mics = await AgoraRTC.getMicrophones();
          setCurrentMic(mics[0]);
          setMics(mics);
  
          // Create and publish microphone track
          rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
            AEC: false,
            ANS: false,
            AGC: false,
            encoderConfig: {
              sampleRate: 48000,
              sampleSize: 16,
              channelCount: 2,
              bitrate: 192,
            },
          });
  
          if (coHost) {
            await rtc.client.publish(rtc.localAudioTrack);
            rtc.localAudioTrack.setEnabled(false); // Initially mute for cohost
          }
        } catch (error) {
          console.error("Error creating microphone track:", error);
        }
      }
  
      // Initialize video for host (unless OBS is used)
      if (role === "host" && !isObs) {
        try {
          const mic = await AgoraRTC.getMicrophones();
          setCurrentMic(mic[0]);
          setMics(mic);
          const cameras = await AgoraRTC.getCameras();
          if (cameras.length > 0) {
            const selectedCamera = cameras.find(cam => cam.label.includes("OBS")) || cameras[0];
            setCurrentCamera(selectedCamera);
            setCamera(cameras);
  
            rtc.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
              encoderConfig: "1080p_5",
              optimizationMode: "detail",
              bitrateMax: 4780,
              bitrateMin: 65,
              frameRate: { max: 60, min: 5 },
              height: { max: 1280, min: 720 },
              width: { max: 1280, min: 720 },
            });
  
            await rtc.localVideoTrack.setDevice(selectedCamera.deviceId);
            await rtc.client.publish(rtc.localVideoTrack);
            setVideo(true); // Update state to indicate video is active
  
            // Setup video element in the DOM
            const playerContainer = document.getElementById("local_stream_container");
            const isDiv = document.getElementById(`local_stream${uid}`);
            if (!isDiv) {
              const el = document.createElement("div");
              el.id = `local_stream${uid}`;
              setupVideoElement(el, uid, playerContainer, coHost);
              rtc.localVideoTrack.play(el);
            }
          }
        } catch (error) {
          console.error("Error initializing camera track:", error);
          notifier.error(t("notifier.error.toast17"));
        }
      }
  
      setIsJoined(true); // Mark as joined for UI
  
      // Setup additional event listeners
      rtc.client.on("user-published", handleUserPublished);
      rtc.client.on("user-joined", handleUserJoined);
      rtc.client.on("user-left", handleUserLeft);
      rtc.client.on("user-unpublished", handleUnPublised);
      rtc.client.on("volume-indicator", handleVolume);
      rtc.client.on("media-reconnect-start", user => console.log(user));
      rtc.client.on("media-reconnect-end", user => console.log(user));
      rtc.client.on("connection-state-change", (currentState, prevState) => {
        console.log(`CurrentState:${currentState}:::::preState:${prevState}`);
        if (currentState === "RECONNECTING") {
          notifier.error(t("noInternet.text1"));
          setTimeout(() => endStream(), 4000);
        }
      });
  
    } catch (error) {
      console.error("Error joining channel:", error);
      dispatch(leaveStream());
    }
  }
  
  // Helper function to set up the video element
  function setupVideoElement(el, uid, playerContainer, coHost) {
    // Placeholder image when no video is present
    const noVideo = document.createElement("div");
    const img = document.createElement("img");
    noVideo.className = "_no_video";
    noVideo.id = `_no_video${uid}`;
    img.src = (findUid(uid)?.user?.profileImg?.filePath || userDetail?.profileImg?.filePath) || Images.default_user_square;
    noVideo.appendChild(img);
    el.appendChild(noVideo);
  
    // Pin button setup
    const pin = document.createElement("img");
    pin.src = Images.pin;
    pin.title = "pin to center";
    pin.id = `pin${uid}`;
    pin.className = "_pin_class";
    pin.addEventListener("click", event => handlePinClick(event, el, uid, isOwner));
    el.appendChild(pin);
  
    // Append the video element to the player container
    if (playerContainer && playerContainer.children.length === 0) {
      el.className = "_pin_";
      playerContainer.appendChild(el);
    } else {
      const cohostContainer = document.getElementById("cohost_video_box") || createCohostContainer(playerContainer);
      el.className = "_un_pin_";
      cohostContainer.appendChild(el);
    }
  }
  
  // Handle pin functionality for video elements
  function handlePinClick(event, el, uid, isOwner) {
    const cohostContainer = document.getElementById("cohost_video_box");
    const playerContainer = document.getElementById("local_stream_container");
  
    if (!cohostContainer || !playerContainer) return;
  
    // Unpin current element and pin selected one
    if (playerContainer.firstChild && playerContainer.firstChild !== el) {
      playerContainer.firstChild.className = "_un_pin_";
      cohostContainer.appendChild(playerContainer.firstChild);
    }
  
    el.className = "_pin_";
    playerContainer.insertBefore(el, playerContainer.firstChild);
    if (isOwner) layout(el.id.substring(3));
  }
  
  // Create the cohost container if it doesn't exist
  function createCohostContainer(playerContainer) {
    const cohostContainer = document.createElement("div");
    cohostContainer.id = "cohost_video_box";
    playerContainer.style.gridTemplateColumns = "1fr 165px";
    playerContainer.appendChild(cohostContainer);
    return cohostContainer;
  }
  

  const addStream = async (songId, playListId) => {
    try {
      const payload = {
        userId: getUserId(),
        musicId: songId,
        inPlaylist: true,
      };
      if (playListId) payload["playlistId"] = playListId;
      const response = await ApiService.STREAM_ADD(payload);
      localStorage.setItem(
        "streamingBalance",
        response["result"].streamingBalance
      );

      // console.log(response);
    } catch (error) {
      console.log(getErrorString(error));
    }
  };

  const handleFile = async (
    song,
    playlistSongs,
    index,
    prevIndex,
    restart,
    volume,
    preSong
  ) => {
    //return if song already playing
    if (playlistSongs[index].isPlaying && !restart) return;
    //stop previous song
    if (prevIndex >= 0 && index != prevIndex) {
      playlistSongs[prevIndex].isPlaying = false;
      if (interval) {
        clearInterval(interval);
      }

      handleStopSong(playlistSongs[index]._id);
    }
    playlistSongs[index].lastPlaying = false;
    const file = song;
    if (!restart && !obs) {
      audioFileTrack = await AgoraRTC.createBufferSourceAudioTrack({
        source: file,
      });
    }

    // Start processing the audio data from the audio file.
    audioFileTrack?.startProcessAudioBuffer();
    audioFileTrack?.setVolume(volume);
    // Publish audioFileTrack and localAudioTrack together.
    if (!restart) await rtc.client.publish([audioFileTrack]);
    setPlay(true);
    let progress = 0;
    // audioFileTrack?.start();

    const updateProgress = async () => {
      const cT = Math.floor(audioFileTrack?.getCurrentTime());
      const du = Math.floor(audioFileTrack?.duration);
      const prg = (cT * 100) / du;
      localStorage.setItem("curretTimeInSong", audioFileTrack?.getCurrentTime());


      progress = audioFileTrack?.getCurrentTime();
      // dispatch(updatePos(progress));
      if (audioFileTrack?.currentState === "playing") {
        dispatch(
          start({
            index: index,
            songs: playlistSongs,
            pos: progress,
            track: audioFileTrack,
            vol: audioFileTrack?._volume,
          })
        );
      }

      // Handle if the audioFileTrack is paused
      if (audioFileTrack?.currentState === "paused") {
        clearInterval(interval); // Clear the interval to stop updates


        return;
      }
      if (audioFileTrack?.currentState === "stopped") {
        playlistSongs[index].isPlaying = false;
        playlistSongs[index].lastPlayed = true;
        if (progress === 0 && playlistSongs[index]["streamed"]) {
          playlistSongs[index]["streamed"] = false;
        }
        socket.emit("song-start", {
          roomId: streamDataLocal._id,
          ownerId: userId,
          type: "stop",
          _id: playlistSongs[index]._id,
        });
        localStorage.setItem("streamIndex", -1);
        dispatch(
          start({
            index: index,
            songs: playlistSongs,
            pos: 0,
            track: audioFileTrack,
          })
        );
        putRecord(
          "stop",
          playlistSongs[index]._id,
          streamDataLocal._id,
          index,
          audioFileTrack?.getCurrentTime(),
          new Date().getTime(),
          playlistSongs
        );
        clearInterval(interval);
        if (index < playlistSongs.length - 1) {
          // play next if current song end
          const nextSong = await fetchSong(
            playlistSongs[index + 1].fileId.filePath
          );
          putRecord(
            "next",
            playlistSongs[index + 1]._id,
            streamDataLocal._id,
            index + 1,
            0,
            null,
            playlistSongs
          );
          handleFile(
            nextSong,
            playlistSongs,
            index + 1,
            index,
            false,
            audioFileTrack?._volume
          );
        }
      }
    };
    if (prevIndex >= 0) playlistSongs[prevIndex].lastPlayed = false;
    if (count && audioFileTrack) {
      audioFileTrack?.stopProcessAudioBuffer();
    } else audioFileTrack?.play();
    if (!count && audioFileTrack) interval = setInterval(updateProgress, 1000);

    // if (count % 3 === 0 && count !== 0) {
    //   audioFileTrack?.stopProcessAudioBuffer();
    //   playlistSongs[index].isPlaying = false;
    //   clearInterval(interval);
    // }

    playlistSongs[index].isPlaying = true;
    localStorage.setItem("streamIndex", index);
    dispatch(
      start({
        index: index,
        songs: playlistSongs,
        pos: 0,
        track: audioFileTrack,
        vol: volume,
      })
    );
    const userId = getUserId();
    socket.emit("song-start", {
      song: playlistSongs[index].title,
      _id: playlistSongs[index]._id,
      thumbnailImg: playlistSongs[index].thumbnailImg,
      ownerId: userId,
      roomId: streamDataLocal._id,
      type: "start",
      artist: playlistSongs[index]?.artist,
    });
    putRecord(
      "start",
      playlistSongs[index]._id,
      streamDataLocal._id,
      index,
      0,
      null,
      playlistSongs
    );
  };

  const putRecord = async (
    event,
    musicId,
    playlistId,
    index,
    timeInSong,
    associationId,
    playlistSongs
  ) => {
    const userId = getUserId();
    const audienceArray = await getAudienceId(liveUser);
    const payload = {
      eventType: event,
      timestamp: new Date().getTime(),
      userId: userId,
      musicId: musicId,
      playlistId: playlistId,
      livestreamId: playlistId,
      songDetails: playlistSongs[index],
      timeInSong: timeInSong,
      associationId: associationId,
      audienceArray: audienceArray,
    };
    putStreamRecord(payload);
  };
  const fetchSong = async (filePath) => {
    try {
      const response = await fetchWithProgress(filePath);

      const file = await response.blob();
      return file;
      // onLoader(false);
    } catch (error) {
      return null;
    }
  };

  const fetchWithProgress = async (url) => {
    const response = await fetch(url);
    const reader = response.body.getReader();
    const stream = new ReadableStream({
      start(controller) {
        const pump = () =>
          reader.read().then(({ done, value }) => {
            if (done) {
              controller.close();
              return;
            }
            controller.enqueue(value);

            return pump();
          });
        return pump();
      },
    });

    return new Response(stream, response);
  };

  const handleStopSong = async (musicId) => {
    audioFileTrack?.stopProcessAudioBuffer();
    await rtc.client.unpublish([audioFileTrack]);
    // rtc.localAudioTrack.setEnabled(true);
    audioFileTrack = null;
    setPlay(false);
    // socket.emit("song-start", {
    //   roomId: streamDataLocal._id,
    //   type: "stop",
    //   ownerId: userId,
    //   _id: musicId,
    // });
  };

  const toggleCohostCamera = (user, camera) => {
    socket.emit("mute", {
      userId: user._id,
      channelName: streamDataLocal._id,
      mic: user.mic,
      micChange: false,
      camera: camera,
    });
    setOpenUser(false);
  };

  async function handleVolume(volumes) {
    volumes.forEach((volume) => {
      const user = document.getElementById(`local_stream${volume.uid}`);
      const users = document.getElementById("local_stream_container");
      const cohosts = document.getElementById("cohost_video_box");
      if (users)
        for (let index = 0; index < users.children.length; index++) {
          const element = users.children[index];
          if (element.id === `local_stream${volume.uid}` && volume.level > 0) {
            if (user && !document.getElementById(`speaking${volume.uid}`)) {
              const img = document.createElement("img");
              img.id = `speaking${volume.uid}`;
              img.src = Images.speaking;

              user.style.position = "relative";
              img.className = "_speaking";
              user.appendChild(img);
            }
          } else if (
            element.id === `local_stream${volume.uid}` &&
            user &&
            user.children.length > 1
          ) {
            if (document.getElementById(`speaking${volume.uid}`))
              document.getElementById(`speaking${volume.uid}`).remove();
          }
        }
      if (cohosts)
        for (let index = 0; index < cohosts.children.length; index++) {
          const element = cohosts.children[index];
          if (element.id === `local_stream${volume.uid}` && volume.level > 0) {
            if (user && !document.getElementById(`speaking${volume.uid}`)) {
              const img = document.createElement("img");
              img.id = `speaking${volume.uid}`;
              img.src = Images.speaking;

              user.style.position = "relative";
              img.className = "_speaking";
              user.appendChild(img);
            }
          } else if (
            element.id === `local_stream${volume.uid}` &&
            user &&
            user.children.length > 1
          ) {
            if (document.getElementById(`speaking${volume.uid}`))
              document.getElementById(`speaking${volume.uid}`).remove();
          }
        }
    });
  }

  async function handleUnPublised(user, mediaType) {
    if (mediaType === "video") {
      const id = user.uid;
      delete remoteUsers[id];
      if (!user.hasVideo && user?._video_added_) {
      } else {
        const local_stream = document.getElementById(`local_stream${id}`);
        if (local_stream) local_stream.remove();
        const cohost = document.getElementById("cohost_video_box");
        const playerContainer = document.getElementById(
          "local_stream_container"
        );
        if (cohost && cohost.children.length === 0) {
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer &&
          playerContainer.children.length === 1 &&
          cohost &&
          cohost.children.length === 0
        ) {
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer &&
          playerContainer.children.length > 1 &&
          cohost &&
          cohost.children.length === 0
        ) {
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer &&
          playerContainer.children.length === 1 &&
          cohost &&
          cohost.children.length === 1
        ) {
          cohost.firstChild.className = "_pin_";
          playerContainer.insertBefore(cohost.firstChild, cohost);
          cohost.remove();
          playerContainer.style.gridTemplateColumns = "auto";
          playerContainer.style.gridTemplateRows = "none";
          const pin = document.getElementsByClassName("_pin_");
          if (pin) pin[0].style.gridRows = "1";
        } else if (
          playerContainer &&
          playerContainer.children.length === 1 &&
          cohost &&
          cohost.children.length > 1
        ) {
          cohost.firstChild.className = "_pin_";
          cohost.firstChild.style.gridRows = "1";
          playerContainer.insertBefore(cohost.firstChild, cohost);
        }
      }
    }
  }

  async function handleUserPublished(user, mediaType) {
    const id = user.uid;
    remoteUsers[id] = user;
    subscribe(user, mediaType);
  }

  function handleUserJoined(user, mediaType, isObs) {
    const id = user.uid;
    remoteUsers[id] = user;
    subscribe(user, mediaType, isObs);
  }

  function handleUserLeft(user) {
    const id = user.uid;
    delete remoteUsers[id];

    if (!user.hasVideo && user?._video_added_) {
    } else {
      const local_stream = document.getElementById(`local_stream${id}`);
      if (local_stream) local_stream.remove();
      const cohost = document.getElementById("cohost_video_box");
      const playerContainer = document.getElementById("local_stream_container");
      if (cohost && cohost.children.length === 0) {
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer &&
        playerContainer.children.length === 1 &&
        cohost &&
        cohost.children.length === 0
      ) {
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer &&
        playerContainer.children.length > 1 &&
        cohost &&
        cohost.children.length === 0
      ) {
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer &&
        playerContainer.children.length === 1 &&
        cohost &&
        cohost.children.length === 1
      ) {
        cohost.firstChild.className = "_pin_";
        playerContainer.insertBefore(cohost.firstChild, cohost);
        cohost.remove();
        playerContainer.style.gridTemplateColumns = "auto";
        playerContainer.style.gridTemplateRows = "none";
        const pin = document.getElementsByClassName("_pin_");
        if (pin) pin[0].style.gridRows = "1";
      } else if (
        playerContainer &&
        playerContainer.children.length === 1 &&
        cohost &&
        cohost.children.length > 1
      ) {
        cohost.firstChild.className = "_pin_";
        cohost.firstChild.style.gridRows = "1";
        playerContainer.insertBefore(cohost.firstChild, cohost);
      }
    }
  }

  async function subscribe(user, mediaType, isObs) {
    if (user) {
      if (mediaType) await rtc.client.subscribe(user, mediaType);
      // if (mediaType === "video") {
      if (!Uid.current) Uid.current = user.uid;
      // if (isOwner) {
      const isDiv = document.getElementById(`local_stream${user.uid}`);
      const playerContainer = document.getElementById("local_stream_container");
      const el = document.createElement("div");
      let isplayer;
      if (isDiv) {
        Array.from(isDiv.children).forEach((e) => {
          if (e.id.includes("agora-video-player-track-video")) isplayer = true;
        });
      }
      if (isDiv && !isplayer) {
        if (mediaType === "video" && user.videoTrack)
          user.videoTrack.play(isDiv);
      } else if (!isDiv) {
        el.id = `local_stream${user.uid}`;
        const noVideo = document.createElement("div");
        const img = document.createElement("img");
        noVideo.className = "_no_video";
        noVideo.id = noVideo.id = `_no_video${user.uid}`;
        const foundUser = findUid(user.uid);
        if (foundUser && foundUser?.user)
          img.src =
            foundUser?.user?.profileImg?.filePath || Images.default_user_square;
        else img.src = Images.default_user_square;
        noVideo.appendChild(img);
        el.appendChild(noVideo);
        if (mediaType === "video" && user.videoTrack) user.videoTrack.play(el);
        el.className = "_un_pin_";
        const pin = document.createElement("img");
        pin.src = Images.pin;
        pin.id = `pin${user.uid}`;
        pin.title = "pin to center";
        pin.addEventListener("click", function (event) {
          const cohost = document.getElementById("cohost_video_box");
          const playerContainer = document.getElementById("local_stream_container");
      
          if (!cohost || !playerContainer) return;
      
          // Unpin the current playerContainer's first child if needed
          if (playerContainer.firstChild && playerContainer.firstChild !== cohost) {
              playerContainer.firstChild.className = "_un_pin_";
              cohost.appendChild(playerContainer.firstChild);
          }
      
          Array.from(cohost.children).forEach((child) => {
              if (child === event.currentTarget.parentNode) { // Adjusted to match the clicked pin's container
                  child.className = "_pin_";
                  playerContainer.insertBefore(child, playerContainer.firstChild);
                  if (isOwner) layout(child.id.substring(3));
              } else {
                  child.className = "_un_pin_";
              }
          });
      });
      
        
        
        pin.className = "_pin_class";
        el.appendChild(pin);
        if (playerContainer && playerContainer.children.length === 0) {
          el.className = "_pin_";
          playerContainer.appendChild(el);
        } else {
          const cohostlist = document.createElement("div");
          const isCoHosts = document.getElementById("cohost_video_box");
          if (!isCoHosts && playerContainer) {
            cohostlist.id = "cohost_video_box";
            el.className = "_un_pin_";
            cohostlist.appendChild(el);
            // if (history.location.pathname.includes("/LiveVideoStreaming")) {
            //   playerContainer.style.gridTemplateColumns = "1fr";
            //   playerContainer.style.gridTemplateRows = "165px 1fr";
            // } else
            playerContainer.style.gridTemplateColumns = "1fr 165px";
            playerContainer.appendChild(cohostlist);
          } else if (isCoHosts && playerContainer) {
            el.className = "_un_pin_";

            isCoHosts.appendChild(el);
          }
        }
      }

      // If the subscribed track is audio.
      if (mediaType === "audio") {
        setUserStream(user);
        var isSafari =
          /constructor/i.test(window.HTMLElement) ||
          (function (p) {
            return p.toString() === "[object SafariRemoteNotification]";
          })(
            !window["safari"] ||
            (typeof safari !== "undefined" &&
              window["safari"].pushNotification)
          );
        if (isSafari) navigator.mediaDevices.getUserMedia({ audio: true });
        if (screenWidth() < 700) {
          const isDiv = document.getElementById(`local_stream${user.uid}`);
          if (isDiv && user.audioTrack)
            user.audioTrack.play(isDiv, { muted: true });
        } else if (user.audioTrack) user.audioTrack.play();
        // user.audioTrack.setVolume(10);
      }
      // const isDiv = document.getElementById(`local_stream${user.uid}`);

      if (
        isDiv &&
        isDiv.children.length > 1 &&
        document.getElementsByClassName("agora_video_player") &&
        screenWidth() < 700
      ) {
        const unmute = document.createElement("img");
        unmute.src = Images.unmute;
        unmute.className = "taptostart";
        unmute.id = `unmute${user.uid}`;
        isDiv.appendChild(unmute);
        document.body.addEventListener("touchstart", function () {
          for (const key in remoteUsers) {
            if (remoteUsers[key]._audioTrack) {
              remoteUsers[key]._audioTrack.play(isDiv, { muted: false });
              unmute.remove();
            }
          }
        });
        // if (videoId)
      }
    }
    if (isObs) {
      // const isCoHosts = document.getElementById("cohost_video_box");
      // console.log("isCoHosts", isCoHosts);
      const local_stream_container = document.getElementById(
        "local_stream_container"
      );
      local_stream_container.style.gridTemplateColumns = "none";
      document.getElementById("cohost_video_box").remove();
    }
  }

  const layout = async (uid) => {
    try {
      const response = await ApiService.LAYOUT(
        `channelName=${streamDataLocal._id}&uid=${uid}`
      );
    } catch (error) {
      console.log("Lstraing recording layoyt api call:", error);
    }
  };

  function findUid(userUid) {
    for (let index = 0; index < liveUserRef.current.length; index++) {
      const element = liveUserRef.current[index];
      if (element.uid === userUid) {
        return element;
      }
    }
    return null;
  }

  async function shareScreen(channel, token, appId) {
    if (!obs) {
      try {
        AgoraRTC.createScreenVideoTrack({
          // Set the encoder configurations. For details, see the API description.
          withAudio: "enable",
          encoderConfig: "1080p_3",
          optimizationMode: "detail",
        })
          .then(async (localScreenTrack) => {
            rtc_screen.client = AgoraRTC.createClient({
              mode: "rtc",
              codec: "h264",
            });
            // if (rtc.localAudioTrack) leaveEventHost('host');
            const uid = await rtc_screen.client.join(
              appId,
              channel,
              token,
              null
            );
            rtc_screen.localScreenTrack = localScreenTrack;
            rtc_screen.uid = uid;
            await rtc_screen.client.publish([rtc_screen.localScreenTrack]);
            // if (
            //   liveUser.length > 0 &&
            //   audienceIndex !== null &&
            //   liveUser["audienceIndex"]?.user.role === "host"
            // ) {
            //   socket.emit("requestToCoHost", {
            //     userId: audienceRole._id,
            //     role: "audience",
            //     channelName: streamDataLocal._id,
            //     host: userId,
            //     joined: false,
            //   });
            //   setAudienceIndex(null);
            //   // setAudienceRole({});
            // }

            setIsVideo(false);
          })
          .catch((err) => { });
      } catch (error) {
        // console.log(error, "********************");
      }
    }
  }

  async function leaveScreenShare(params) {
    rtc_screen.localScreenTrack.close();
    rtc_screen.client.unpublish(rtc.localScreenTrack, function (err) {
      // console.log("publish failed");
      console.error(err);
    });
    delete rtc_screen.localScreenTrack;

    rtc_screen.client.leave(function (ev) {
      // console.log(ev);
    });
    rtc_screen.isVideo = true;
    rtc_screen.client = null;
    const playerContainer = document.getElementById(
      `local_stream${rtc_screen.uid}`
    );
    if (playerContainer) playerContainer.remove();
    setIsVideo(true);
  }

  async function mute(isHostMuted, coHost) {
    if (rtc.localAudioTrack) {
      if (rtc.localAudioTrack.enabled) rtc.localAudioTrack.setEnabled(false);
      else rtc.localAudioTrack.setEnabled(true);
      setIsMute((isMute) => !isMute);
      if (coHost) setHostMuted(isHostMuted); //host controlling cohost mute function
      if (!coHost) {
        socket.emit("stream-invite", {
          userId: userId,
          channelName: streamDataLocal._id,
          role: "host",
          mic: !rtc.localAudioTrack.enabled,
        });
      }
    } else {
      if (!obs) {
        rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
          encoderConfig: "high_quality_stereo",
          bitrate: 192,
          sampleRate: 48,
          stereo: true,
        });
      }
      rtc.client.publish(rtc.localAudioTrack);
      setIsMute((isMute) => !isMute);
    }
  }

  async function disableVideo(False) {
    if (rtc.localVideoTrack) {
      if (rtc.localVideoTrack.enabled) rtc.localVideoTrack.setEnabled(false);
      else rtc.localVideoTrack.setEnabled(true);
      const noVideo = document.getElementById(`_no_video${option.uid}`);
      if (noVideo)
        noVideo.style.zIndex = rtc.localVideoTrack.enabled ? "1" : "-1";
      if (False) setIsJoined(!rtc.localVideoTrack.enabled);
    } else {
      if (!obs) {
        rtc.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
          // Set the encoder configurations. For details, see the API description.
          encoderConfig: "1080p_5",
          optimizationMode: "detail",
          bitrateMax: 4780,
          bitrateMin: 65,
          frameRate: { max: 60, min: 5 },
          height: { max: 1280, min: 720 },
          width: { max: 1280, min: 720 },
        });
      }
      rtc.client.publish(rtc.localVideoTrack);
      const el = document.getElementById(`local_stream${option.uid}`);
      if (el) {
        rtc.localVideoTrack.play(el);
        setIsJoined(true);
        setVideo(true);
      }

      // Create a video track from the video captured by a camera.
    }
  }

  async function leaveEventHost(params) {
    if (rtc.localAudioTrack) rtc.localAudioTrack.close();
    if (rtc.localVideoTrack) rtc.localVideoTrack.close();
    // if (params === "host") await rtc.client.unpublish();
    await rtc.client.leave();
    // }
    const playerContainer = document.getElementById("local_stream");
    if (playerContainer) playerContainer.remove();
  }

  function leaveEventAudience(params) {
    rtc.client.leave(
      function () {

        return true;
        //……
      },
      function (err) {
        //error handling
        return false;
      }
    );
  }
  const openFullScreen = async () => {
    let elem = document.getElementById("__streaming_container");
    if (!elem) {
      setIsFullScreen(true);
      await elem.requestFullscreen();
    }
  }

  const closeFullScreen = async () => {
    if (document.exitFullscreen) {
      setIsFullScreen(false);
      await document.exitFullscreen();
    }
  }

  const openNft = () => {
    setShowNft(true);
  }

  const closeNft = () => {
    setShowNft(true);
  }

  const handleTip = async (amount, id, type, currency) => {
    const userDetail = getUserDetail();
    if (amount) {
      if (openUser) setOpenUser(false);
      setOpenTip(false);
      try {
        const payload = {
          id: id,
          tipAmount: amount,
          type: "livestreamArtist",
          currency: currency,
          playlistId: streamDataLocal._id,
        };
        setLoading(true);
        const response = await ApiService.TIP_ARTIST(payload);

        setLoading(false);

        setUserData({});
        dispatch(getBalance());
      } catch (error) {
        setLoading(false);
        notifier.error(getErrorString(error));
      }
    } else {
      setOpenTip(false);
    }
  };

  const getRoomId = async (userId, senderUserId) => {
    try {
      const response = await ApiService.GET_ROOM_ID(
        `userId=${userId}&senderUserId=${senderUserId}`
      );
      return response?.result?.roomId;
    } catch (error) {
      return null;
    }
  };

  const requestToBeHost = (id, role) => {
    // if (role === "audience") leaveEventAudience();
    // else leaveEventAudience();
    option.role = option.role === "host" ? "audience" : "host";
    socket.emit("requestToCoHost", {
      userId: id,
      role: role,
      channelName: streamDataLocal._id,
      host: userId,
      joined: false,
    });
  };
  const changeToHost = async (id, ROLE, host) => {
    setRole(ROLE);
    if (ROLE === "host") {
      await leaveEventHost();
      rtc.client.setClientRole("host");
      joinChannel(ROLE, streamDataLocal._id, null, option.appId, true);

      socket.emit("stream-invite", {
        userId: userId,
        channelName: streamDataLocal._id,
        role: "host",
        mic: true,
        camera: false,
        changedToHost: true
      });
      setIsMute(false);
      setVideo(false);
      setIsMute(true);
    } else if (ROLE === "audience") {
      await leaveEventHost("host");

      rtc.client.setClientRole("audience");
      handleUserLeft({ uid: option.uid });
      joinChannel(ROLE, streamDataLocal._id, null, option.appId, null);

      socket.emit("stream-invite", {
        userId: userId,
        channelName: streamDataLocal._id,
        role: "audience",
        mic: true,
        camera: false,
      });
      setVideo(true);
      setIsMute(false);
      rtc.localVideoTrack = null;
      rtc.localAudioTrack = null;
    }
  };

  const endStream = (raised) => {

    if (rtc.client) {
      if (rtc_screen.client) leaveScreenShare();
      if (socket) {
        socket.emit("stream-end", {
          channelName: streamDataLocal._id,
          role: isOwner ? "host" : "audience",
          JWT: token,
        });
        // localStorage.setItem("showAd", true);
      }

      if (isOwner && rtc.client) leaveEventHost("host");
      else if (rtc.client) leaveEventAudience("audience");

      // if (playlistId && history.location.pathname.includes("/app/LiveVideoStreaming/")) {
      //   window.location.replace(window.location.origin + "/app/Home");
      // }
      // else {
      //   window.location.reload();
      // }
    }
  };

  useEffect(() => {
    if (rtc?.localAudioTrack && !count && !play) {
      rtc.localAudioTrack.setEnabled(true);
      setIsMute(false);
    }
  }, [count]);

  return (
    <Box
      className={
        "__streaming_container" +
        (history.location.pathname.includes("/app/LiveVideoStreaming/")
          ? " _share_url"
          : "")
      }
      id="__streaming_container"
    >



      {tokenData?.channelName && tokenData?.goal?.totalGoalAmount > 0 ?(
                    <>
                    {/* Place the console.log within JSX */}



          <StreamTippers
            title={tokenData?.goal?.goalTitle}
            goal={tokenData?.goal?.totalGoalAmount}
            goalProgress={tokenData?.goal?.goalProgress}
            liveUser={liveUser.length}
            isOwner={isOwner}
            setStreamTippers={(e) => setTippers(e)}
            channelName={streamDataLocal._id}
            isJoined={isJoined}
            goalDescription={tokenData?.goal?.goalDescription}

            goalAmountReceived={tokenData?.goal?.goalAmountReceived || 0}
            setTokenData={setTokenData} // Add this line
          // Pass goalAmountReceived here


          />
        </>
      ) : null}


      <Box
        sx={{
          position: "fixed",
          bottom: 0,
          left: "50%",
          transform: "translateX(-50%)",
          background: "rgba(0, 0, 0, 0.7)",
          padding: "5px 10px",
          borderRadius: "5px",
          color: "#ffffff",
          textAlign: "left",
          zIndex: 10,
          display: "flex",
          alignItems: "center",
          gap: "10px",
        }}
      >
        {songData?.thumbnailImg ? (
          <Avatar
            sx={{ width: 20, height: 20, marginRight: 1 }}
            src={songData.thumbnailImg.filePath}
          />
        ) : null}

        {songData?.title ? (
          <Typography variant="subtitle2">
            {songData.title} by {songData.artist}
          </Typography>
        ) : (
          <Typography variant="subtitle2"></Typography>
        )}

        {songData?.thumbnailImg ? (
          <IconButton
            size="small"
            variant="contained"
            color="primary"
            onClick={() => setShowPlaylist(true)}
            sx={{
              marginLeft: 1,
              padding: "4px 8px", // Adjust padding for better size control
              fontSize: "0.75rem", // Font size for the text inside the button
              backgroundColor: "#000000", // Background color (same as primary button)
              color: "#FFEE20", // Text color (white)
              borderRadius: "10px", // Rounded corners to match button style
              '&:hover': {
                backgroundColor: "#333333", // Slightly darker shade for hover effect
              },
              display: "flex", // Flex display to align icon and text
              alignItems: "center", // Center-align content
              justifyContent: "center", // Center-align content
            }}
          >
            {/* Image used as the icon inside the IconButton */}
            <img src="/images/Group 11553.svg" alt="add to studio" className="w24 h20" />
          </IconButton>
        ) : null}

        {/* Add to Playlist Modal */}
        {showPlaylist && (
          <AddMusicToPlaylist
            musicId={selectedId}
            open={showPlaylist}
            handleClose={() => setShowPlaylist(false)}
          />
        )}
      </Box>

      {/* {isOwner ? ( */}
      {/* ) : null} */}
      {/* {isOwner ? ( */}
      {obs || fromObs ? (
        <Box
          id="_streaming_canvas"
          className="_streaming_canvas"
          sx={{
            width: "100%",
            height:
              tokenData?.goal?.totalGoalAmount || tippers
                ? "calc(100% - 215px)"
                : "calc(100% - 115px)",
            display: "flex",
            gap: liveUser.length > 0 ? "12px" : "0",
          }}
        >
          <div
            id="local_stream_container"
            className="local_stream_container"
            style={{
              position: "relative",
              width: liveUser.length === 0 ? "100%" : "inherit",
              height: "100%",
              transition: "width 0.2s ease-in-out 0s",
            }}
          >
            {!tokenData?.channelName ? (
              <Loader
                wait={true}
                _class="__loader_inside"
                message={message ? message : t("loader.message23")}
              />
            ) : null}
            <StreamShow
              obsUrl={obsUrl}
              fromObs={fromObs}
              channelName={channel}
            />
          </div>
          {/* </div> */}

          {liveUser.length > 0 ? (
            <Box
              className="_streaming_audience"
              sx={{
                zIndex: "100000",
                height: "100%",
                marginRight: "",
                paddingTop: "15px",
              }}
            >
              {liveUser &&
                liveUser.slice(0, 4).map((u, index) => (
                  <Box
                    onClick={() => setOpenUser(true)}
                    key={index}
                    className="_streaming_audience_box"
                    sx={{ backgroundColor: "#1E1E1E", cursor: "pointer" }}
                  >
                    <img
                      className="_streaming_audience_box_image"
                      src={
                        u?.user?.profileImg?.filePath ||
                        Images.default_user_square
                      }
                      alt=""
                    />
                    <Stack
                      className="_streaming_audience_box_user_detail"
                      direction="row"
                      spacing={1}
                    >
                      <span className="_online"></span>
                      <Typography className="fs-9 light-text">
                        {fullName(u?.user, 15)}
                      </Typography>
                    </Stack>
                  </Box>
                ))}
              {liveUser.length > 4 ? (
                <Box
                  className="_streaming_audience_box_more"
                  onClick={() => setOpenUser(true)}
                >
                  <Typography
                    className="24 fw-b _cp"
                    sx={{
                      height: "inherit",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    +{liveUser.length - 4}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          ) : null}
        </Box>
      ) : (
        <Box
          id="_streaming_canvas"
          className="_streaming_canvas"
          sx={{
            width: "100%",
            // height:
            //   tokenData?.goal?.totalGoalAmount || tippers
            //     ? "calc(100% - 215px)"
            //     : "calc(100% - 115px)",
            // height: "100%",
            height:
              tokenData?.goal?.totalGoalAmount || tippers
                ? "calc(100% - 215px)"
                : "calc(100% - 183px)",
            display: "flex",
            gap: liveUser.length > 0 ? "12px" : "0",
          }}
        >
          <div
            id="local_stream_container"
            className="local_stream_container"
            style={{
              position: "relative",
              width: liveUser.length === 0 ? "100%" : "inherit",
              height: "100%",
              // !tokenData?.goal?.totalGoalAmount && !tippers
              //   ? "calc(100% - 66px)"
              //   : tokenData?.goal?.totalGoalAmount || tippers
              //   ? "calc(100% - 68px)"
              //   : "calc(100% - 66px)",

              transition: "width 0.2s ease-in-out 0s",
            }}
          >
            {!tokenData?.channelName ? (
              <Loader
                wait={true}
                _class="__loader_inside"
                message={message ? message : t("loader.message23")}
              />
            ) : null}
          </div>

 <div>

  {/* Button to show ActiveListings */}
  {!showActiveListings && (
    <div
      style={{
        position: 'fixed',
        top: '50%',
        right: '10px', // Space from the edge
        transform: 'translateY(-50%)',
        zIndex: 1000, // Keeps it above most other elements
        pointerEvents: 'none', // Only the button is clickable
      }}
    >
      <IconButton
        onClick={() => setShowActiveListings(true)}
        sx={{
          backgroundColor: '#353535',
          color: '#FFFFFF',
          borderRadius: '50%',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.3)',
          '&:hover': {
            backgroundColor: '#6A6A9F',
          },
        }}
        style={{
          pointerEvents: 'auto', // Make the button itself clickable
        }}
      >
        <GavelIcon />
      </IconButton>
    </div>
  )}

  {/* Render the ActiveListings component if showActiveListings is true */}
  {showActiveListings && (
    <ActiveListings
      streamData={streamData?.createdBy}
      userId={userId}
      role={role}
      isOwner={isOwner}
      onClose={() => setShowActiveListings(false)}
    />
  )}
</div>

          {/* </div> */}
          {liveUser.length > 0 ? (
            <Box
              className="_streaming_audience"
              sx={{
                zIndex: "100000",
                height: "100%",
                marginRight: "",
                paddingTop: "15px",
                // !tokenData?.goal?.totalGoalAmount && !tippers
                //   ? "calc(100% - 66px)"
                //   : tokenData?.goal?.totalGoalAmount || tippers
                //   ? "calc(100% - 68px)"
                //   : "calc(100% - 66px)",
              }}
            >
              {liveUser &&
                liveUser.slice(0, 4).map((u, index) => (
                  <Box
                    onClick={() => setOpenUser(true)}
                    key={index}
                    className="_streaming_audience_box"
                    sx={{ backgroundColor: "#1E1E1E", cursor: "pointer" }}
                  >
                    <img
                      className="_streaming_audience_box_image"
                      src={
                        u?.user?.profileImg?.filePath ||
                        Images.default_user_square
                      }
                      alt=""
                    />
                    <Stack
                      className="_streaming_audience_box_user_detail"
                      direction="row"
                      spacing={1}
                    >
                      <span className="_online"></span>
                      <Typography className="fs-9 light-text">
                        {fullName(u?.user, 15)}
                      </Typography>
                    </Stack>
                  </Box>
                ))}
              {liveUser.length > 4 ? (
                <Box
                  className="_streaming_audience_box_more"
                  onClick={() => setOpenUser(true)}
                >
                  <Typography
                    className="24 fw-b _cp"
                    sx={{
                      height: "inherit",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    +{liveUser.length - 4}
                  </Typography>
                </Box>
              ) : null}
            </Box>
          ) : null}
        </Box>
      )}

 {/* Streaming controls for HOST */}
{!tokenData?.token ? null : (
  <>
    <StreamingControls
      sx={{ zIndex: 10000 }} // Set a high z-index value
      artistId={streamDataLocal.createdBy}
      userData={userData} // Pass userData as a prop
      userStream={userStream}
      play={play}
      handleFile={handleFile}
      liveUsers={liveUser}
      handleStopSong={handleStopSong}
      currentMic={currentMic}
      switchAudio={async (label) => {
        const current = mics.find((mic) => mic.label === label);
        if (current) {
          await rtc.localAudioTrack.setDevice(current.deviceId);
          setCurrentMic(current);
        }
      }}
      switchVideo={async (label) => {
        const current = cameras.find((camera) => camera.label === label);
        if (current) {
          await rtc.localVideoTrack.setDevice(current.deviceId);
          setCurrentCamera(current);
        }
      }}
      mics={mics}
      cameras={cameras}
      currentCamera={currentCamera}
      streamData={streamDataLocal}
      raisedList={raisedList}
      isJoined={isJoined}
      role={role}
      liveUser={liveUser.length}
      tokenData={tokenData}
      isOwner={isOwner}
      leaveStreaming={(raised) => {
        if (raised) endStream(raised);
        else setSuccess(true);
      }}
      playlistId={streamDataLocal._id}
      title={streamDataLocal.title}
      mute={() => mute(isMute)}
      disableVideo={() => {
        disableVideo();
        const state = video;
        setVideo(null);
        setTimeout(() => setVideo(!state), 500);
      }}
      isMute={isMute}
      hostMuted={hostMuted}
      video={video}
      isVideo={isVideo}
      shareScreen={(isShared) => {
        shareScreen(tokenData.channelName, tokenData.token, tokenData.appId);
      }}
      stopShare={leaveScreenShare}
      isFullScreen={isFullScreen}
      userId={userId}
      obs={obs}
    />
  </>
)}

      {/* {loading  ? (
        <Loader wait={true} _class="__loader_inside" message="sending tip..." />
      ) : null} */}
      {openUser ? (
        <TopListPopup
          followings={followings}
          channelName={streamDataLocal._id}
          isOwner={isOwner}
          isUsers={true}
          title={`${t("topListPopup.title3")} (${liveUser.length > 1 ? liveUser.length - 1 : 0})`}
          open={openUser}
          data={liveUser}
          isArray={true}
          handleClose={() => setOpenUser(false)}
          isLiveUser={false}
          onTipPoupOpen={(e) => {
            setOpenTip(true);
            setUserData({ ...e });
          }}
          onNftPoupOpen={(e) => {
            setOpenUser(false);
            setShowNft(true);
            setUserData({ ...e });
          }}
          onRequestToHost={(id, index, user) => {
            requestToBeHost(id, user.role === "audience" ? "host" : "audience");
            setAudienceIndex(index);
            setOpenUser(false);
          }}
          switchAudio={async (label) => {
            // Find the microphone based on the label
            const current = mics.find((mic) => mic.label === label);

            if (current) {
              // Check if rtc.localAudioTrack is available and not muted
              if (rtc.localAudioTrack && typeof rtc.localAudioTrack.setDevice === 'function') {
                try {
                  await rtc.localAudioTrack.setDevice(current.deviceId);
                  setCurrentMic(current);
                } catch (error) {
                  console.error("Error switching audio device:", error);
                }
              } else if (!rtc.localAudioTrack) {
                console.error("Audio track is not initialized or has been muted");
                // You might want to reinitialize the audio track when muted
                try {
                  rtc.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack();
                  await rtc.localAudioTrack.setDevice(current.deviceId);
                  setCurrentMic(current);
                  rtc.client.publish(rtc.localAudioTrack);
                } catch (error) {
                  console.error("Error reinitializing or setting device on audio track:", error);
                }
              } else {
                console.error("rtc.localAudioTrack or setDevice is undefined");
              }
            } else {
              console.error("Selected microphone not found");
            }
          }}
          switchVideo={async (label) => {
            const current = cameras.find((camera) => camera.label === label);
            if (current) {
              await rtc.localVideoTrack.setDevice(current.deviceId);
              setCurrentCamera(current);
            }
          }}
          mics={mics}
          cameras={cameras}
          currentMic={currentMic}
          currentCamera={currentCamera}
          obs={obs}
        />
      ) : null}
      {showNft ? (
        <NftList
          style={{ right: "0", width: "444px", zIndex: 100000 }}
          onClose={() => {
            setShowNft(false);
            setUserData({});
          }}
          fullName={fullName(userData)}
          toUser={userData._id}
        />
      ) : null}
      {openTip ? (
        <TipPopup
          artist={fullName(userData)}
          id={userData._id}
          open={openTip}
          isArtist={true}
          isPlaylist={false}
          handleClose={handleTip}
        />
      ) : null}
      {success ? (
        <SuccessPopup
          open={success}
          message={t("success.message6")}
          handleClose={() => {
            endStream();
            // dispatch(leaveStream());
          }}
        />
      ) : null}
      {openSnackbar ? (
        <Snackbar
          open={openSnackbar}
          autoHideDuration={3000}
          onClose={() => {
            setOpenSnackbar(false);
            setRaisedUser({});
          }}
          TransitionComponent={Slide}
        >
          <Stack
            className={
              "_open_snackbar" +
              (raisedUser?.user?.userId ? " _open_snackbar_width" : "")
            }
            direction="row"
            alignItems="center"
            spacing={1}
          >
            <PanToolIcon sx={{ fontSize: "15px" }} />
            <Typography className="fs-14">
              {fullName(raisedUser?.user)}
            </Typography>
            <IconButton
              sx={{ marginLeft: "auto !important" }}
              size="small"
              aria-label="close"
              color="inherit"
              onClick={() => {
                setOpenSnackbar(false);
                setRaisedUser({});
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Snackbar>
      ) : null}
    </Box>
  );
}

export default Streaming;